import React, { Component } from 'react'
import LinkedInput from './LinkedInput'
class LinkedPasswordInput extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: this.props.type || 'password'
    }
  }
  getValueFromPath (path) {
    var obj = this.props.context.state
    var stack = path.split('.')
    while (stack.length) {
      obj = obj[stack.shift()]
    }
    return obj
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.value === nextProps.value) return
    this.forceUpdate()
  }
  validate () {
    if (!this.props.validate) return true
    return !!(((this.type.prototype.getValueFromPath.call(this, this.props.path) || '') + '').match(this.props.validate))
  }
  toggleShowPassword () {
    this.setState({ type: (this.state.type === 'password' ? 'text' : 'password') })
  }
  render () {
    return (
      <div className='input-group'>
        <LinkedInput {...this.props} type={this.state.type} hideRequired />
        <span className='input-group-addon ' onClick={(e) => { this.toggleShowPassword() }}>
          <i className='fa fa-eye' />
        </span>
      </div>
    )
  }
}
export default LinkedPasswordInput



// WEBPACK FOOTER //
// ./src/components/basic/inputs/LinkedPasswordInput.js